
export const BookingStatus = {
    /**
     * a customer only made a reservation and hasn't reach an angel's place yet
     */
    READY_FOR_CHECKIN: 'READY_FOR_CHECKIN',
        /**
         * the customer reached his angel successfully
         * and the angel confirmed that he (the angel) has received the customer's bags
         */
        CHECKED_IN: 'CHECKED_IN',
        /**
         * the customer came back to his angel and got his bags back (with angel's confirmation)
         */
        COMPLETED: 'COMPLETED',
        /**
         * order can be changed by admin
         * it creates new booking and suspends the current one
         */
        SUSPENDED: 'SUSPENDED',
        /**
         * order can be change to this status by admin at any time
         */
        REFUNDED: 'REFUNDED',
        /**
         * order can be change to this status by admin at any time
         */
        CLOSED: 'CLOSED',
        /**
         * it happens when the customer will not complete the checkin-check out  procedure
         * in the date of the assumed pick up.
         */
        NO_SHOW : 'NO_SHOW'
}
